import { TimeBoxWrapper, TimeValue, TimeLabel } from "app/components/React/TrialBanner/DiscountBanner/DiscountPopup/StyledDiscountPopup";

import type { FC } from "react";

interface ITimeBoxProps {
    time: number;
    label: string;
}

const TimeBox: FC<ITimeBoxProps> = ({ time, label }) => (
    <TimeBoxWrapper>
        <TimeValue>{time}</TimeValue>
        <TimeLabel>{label}</TimeLabel>
    </TimeBoxWrapper>
);

export default TimeBox;